/**
 * «Юниверситет» (28.09): текст заданий. Из разметки — только **жирный** (MD.inline), и
 * названия треков превращаются в кнопки ▶ (MD.linkTracks). Экранирование — само, это React.
 * В вариантах ответа (они сами кнопки) треки остаются текстом: кнопку в кнопку не вкладываем,
 * да и md.js внутри button треки не ищет. Поле src (ссылка на ролик-источник) в пакет не
 * попадает — «владелец против ссылок-источников в учебном тексте».
 */
import { Fragment, type ReactNode } from "react";
import { TrackButton, useTracks, type TrackApi } from "./TrackPlayer";

function linkTracks(s: string, t: TrackApi | null, plain: boolean, key: string): ReactNode[] {
  if (plain || !t?.re || !s) return [s];
  const out: ReactNode[] = [];
  let last = 0;
  let n = 0;
  for (const m of s.matchAll(t.re)) {
    const title = m[2] ?? m[0];
    const at = (m.index ?? 0) + (m[1] ?? "").length;   // группа 1 — левая граница (не буква)
    const tr = t.find(title);
    if (!tr) continue;
    if (at > last) out.push(s.slice(last, at));
    out.push(<TrackButton key={`${key}-${n++}`} file={tr.file} label={title} />);
    last = at + title.length;
  }
  if (last < s.length) out.push(s.slice(last));
  return out;
}

/** Текст → узлы: **жирный** → <strong>, треки → кнопки (кроме plain). */
export function renderRich(text: string | undefined, t: TrackApi | null, plain = false): ReactNode {
  if (!text) return null;
  const parts = text.split(/\*\*([\s\S]+?)\*\*/g); // нечётные — жирные
  return parts.map((p, i) =>
    i % 2
      ? <strong key={i}>{linkTracks(p, t, plain, `b${i}`)}</strong>
      : <Fragment key={i}>{linkTracks(p, t, plain, `t${i}`)}</Fragment>,
  );
}

export function Rich({ text, plain = false }: { text: string | undefined; plain?: boolean }) {
  const t = useTracks();
  return <>{renderRich(text, t, plain)}</>;
}
